import React from 'react'
import Graphes1 from './graphes/Graphes1'
import Grid from '@mui/material/Grid';
import Graphes2 from './graphes/Graphes2';

function Graphes() {
    return (
        <Grid container id="fenetregraphes">
            {/*
            <Grid className="row">
                <div className="col-12"><img src="images/agrandir.png" alt="agrandir" className="agrandir" /></div>
            </Grid>
            */}

            <div style={{display:"none"}}>
                <div id={"graphe1export"} style={{width:300,height:400}}>
                    <Graphes1 />
                </div>
                <div id={"graphe2export"} style={{width:300,height:400}}>
                    <Graphes2 />
                </div>
            </div>
            <Grid item xs={6}>
                <Graphes1 />
            </Grid>
            <Grid item xs={6}>
                <Graphes2 />
            </Grid>
        </Grid>
    )
}

export default Graphes
